import { trpc, TrpcOutputs } from '../../config/trpc';
import { UseResource } from '../../utils/types';

type AirportTimeZoneOutput = TrpcOutputs['getAirportTimeZone'];
type UseAirportTimeZone = UseResource<AirportTimeZoneOutput, never, never>;

export const useAirportTimeZone = (airportId: string): UseAirportTimeZone => {
  const { isLoading, data, error } = trpc.getAirportTimeZone.useQuery(
    { id: airportId },
    {
      refetchOnWindowFocus: false,
    },
  );

  return {
    data,
    isLoading,
    error: error?.message,
  };
};
